import usColumnDefinitions, { TYPES } from './usColumnDefinitions';

export default ({
  groupByName,
  groupByField,
  groupItem,
  hasSourceCurrency,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => usColumnDefinitions({
  groupByName,
  groupByField,
  groupItem,
  hasSourceCurrency,
  type: TYPES.FEDERAL,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
});
